module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../~/universal-router/~/isarray/index.js
// module id = 625
// module chunks = 2